module.exports = __webpack_public_path__ + "img/info-italic.e380971.svg";